import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { api_routes } from '@app/consts';
import { catchError, map } from 'rxjs/operators';
import { BenefitsGroupSubmit, BenefitsGroupVerbose, DeductionFrequencies } from '../models/benefits-group.model';
import { EnvironmentService } from "@app/core/services/environment.service";

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class BenefitsGroupsService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getGroups(sort?: string, filter?: string, take?: string, skip?: number, asOf?: string,): Observable<any> {
    let params = new HttpParams();
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;
    asOf ? params = params.append('asOf', asOf) : null;
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.GROUPS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteGroup(id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.GROUPS}/${id}`, {
      headers: headers
    });
  }

  getGroup(id: string): Observable<BenefitsGroupVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.GROUPS}/${id}`, {
      headers: headers
    });
  }

  updateGroup(employeeGroup: BenefitsGroupSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.GROUPS}/${employeeGroup.id}`, employeeGroup, {
      headers: headers
    });
  }

  createGroup(employeeGroup: BenefitsGroupSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.GROUPS}`, employeeGroup, {
      headers: headers
    });
  }

  getDeductionFrequencies(): Observable<DeductionFrequencies[]> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.BENEFITS}/${api_routes.DEDUCTION_FREQUENCIES}`, {
      headers: headers
    })
  }



}
